'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var AdjustEffectiveFaresPanelController = function AdjustEffectiveFaresPanelController($scope, dataService, dataTransformerService, saveAdjustedFaresService, configurationService, alignFaresService, saveAdjustmentsService) {
  var NUMBER_OF_COLUMNS = 3;
  var FARE_PRECISION = 2;
  var RBD_LABEL_DEFAULT_CLASS = 'effective-fare-section rbd-label';
  var RBD_LABEL_CLASS_ON_EFFECTIVE_FARE_EDIT = 'effective-fare-section rbd-label-effective-fare-edited';
  var RBD_LABEL_DEFAULT_CLASS_MAPPED = 'effective-fare-section rbd-label-mapped';
  var RBD_LABEL_CLASS_ON_EFFECTIVE_FARE_MAPPED = 'effective-fare-section rbd-label-effective-fare-mapped';
  $scope.$watch('recommendationEntry', function (recommendationEntry) {
    var data = recommendationEntry.data;
    $scope.rbdLabelCustomClass = RBD_LABEL_DEFAULT_CLASS;
    if (data) {
      $scope.numberOfColumns = NUMBER_OF_COLUMNS;
      $scope.columnsRange = _.range($scope.numberOfColumns);
      $scope.showCompareButton = $scope.screenState.recommendationDetailsMode === 'hostView';
      if (recommendationEntry.hostLadder) {
        $scope.regularFbcFareLadder = getRegularFbcsFromFareLadder(recommendationEntry.hostLadder);
        $scope.numberOfRows = Math.ceil($scope.regularFbcFareLadder.length / $scope.numberOfColumns);
        $scope.rowsRange = _.range($scope.numberOfRows);
        $scope.exponentialValues = getSmoothingMethodNames(recommendationEntry.smoothingMethods);
        setAdjustmentDefaultValues();
      }
    }
  }, true);
  function getRegularFbcsFromFareLadder(hostLadder) {
    return _.filter(hostLadder, function (effFare) {
      return _.isNil(effFare.sponsorMarketFbc) && _.isNil(effFare.dualRbdSponsorFbc);
    });
  }
  function getCustomRbdLabelCustomClass(hostFare) {
    if (hostFare.isMappedRbd) {
      return hostFare.recommendedTotalFare === hostFare.effectiveTotalFare ? RBD_LABEL_DEFAULT_CLASS_MAPPED : RBD_LABEL_CLASS_ON_EFFECTIVE_FARE_MAPPED;
    }
    return hostFare.recommendedTotalFare === hostFare.effectiveTotalFare ? RBD_LABEL_DEFAULT_CLASS : RBD_LABEL_CLASS_ON_EFFECTIVE_FARE_EDIT;
  }
  $scope.resetAllFares = function () {
    var clonedHostLadder = _.map($scope.regularFbcFareLadder, function (hostFare) {
      return {
        market: hostFare.market,
        rbd: hostFare.rbd,
        rbdLabel: getRbdLabel(hostFare),
        fbc: hostFare.fbc,
        isMappedRbd: hostFare.isMappedRbd,
        useForLadderGenerationInd: hostFare.useForLadderGenerationInd,
        rbdLabelCustomClass: getCustomRbdLabelCustomClass(hostFare),
        effectiveTotalFare: hostFare.effectiveTotalFare,
        recommendedTotalFare: hostFare.recommendedTotalFare,
        minFareThreshold: Math.round(alignFaresService.getTotalFareThreshold(hostFare.minFareThreshold, hostFare, hostFare.benchmarkFareComponent)),
        maxFareThreshold: Math.round(alignFaresService.getTotalFareThreshold(hostFare.maxFareThreshold, hostFare, hostFare.benchmarkFareComponent)),
        sponsorMarketFbc: hostFare.sponsorMarketFbc,
        dualRbdSponsorFbc: hostFare.dualRbdSponsorFbc,
        percentageLinkageFactor: hostFare.percentageLinkageFactor,
        absoluteLinkageFactor: hostFare.absoluteLinkageFactor,
        effFareClass: 'fare-value effective-fare-section',
        benchmarkFareComponent: hostFare.benchmarkFareComponent,
        yq: hostFare.yq,
        yr: hostFare.yr,
        sixH: hostFare.sixH,
        sixI: hostFare.sixI,
        sixJ: hostFare.sixJ,
        sixK: hostFare.sixK,
        q: hostFare.q,
        airportTax: hostFare.airportTax,
        variable: hostFare.variable,
        variableTaxPercentage: hostFare.variableTaxPercentage,
        actionCode: hostFare.actionCode
      };
    });
    clonedHostLadder.alignedWith = $scope.recommendationEntry.hostLadder.alignedWith;
    clonedHostLadder.competitorHostCarrier = $scope.recommendationEntry.hostLadder.competitorHostCarrier;
    clonedHostLadder.competitorCarrier = $scope.recommendationEntry.hostLadder.competitorCarrier;
    clonedHostLadder.competitorFbc = $scope.recommendationEntry.hostLadder.competitorFbc;
    clonedHostLadder.competitorOrigin = $scope.recommendationEntry.hostLadder.competitorOrigin;
    clonedHostLadder.competitorDestination = $scope.recommendationEntry.hostLadder.competitorDestination;
    clonedHostLadder.competitorTariffCode = $scope.recommendationEntry.hostLadder.competitorTariffCode;
    clonedHostLadder.competitorRoutingNumber = $scope.recommendationEntry.hostLadder.competitorRoutingNumber;
    clonedHostLadder.competitorFootnote = $scope.recommendationEntry.hostLadder.competitorFootnote;
    clonedHostLadder.competitorFareSource = $scope.recommendationEntry.hostLadder.competitorFareSource;
    $scope.clonedHostLadder = clonedHostLadder;
    $scope.clonedHostLadderForDisplay = getRegularFbcsFromFareLadder($scope.clonedHostLadder);
    $scope.adjustEffectiveFareForm.$pristine = true;
  };
  $scope.cancelAdjustments = function () {
    $scope.recommendationEntry.data.showAdjustFares = !$scope.recommendationEntry.data.showAdjustFares;
    setAdjustmentDefaultValues();
  };
  function getRbdLabel(hostFare) {
    var rbdLabel = hostFare.rbd;
    return hostFare.useForLadderGenerationInd === false ? rbdLabel + '*' : rbdLabel;
  }
  function setAdjustmentDefaultValues() {
    $scope.resetAllFares();
    $scope.incrementOrDecrementValue = {
      value: ''
    };
    $scope.defaultExponentialValue = {
      value: $scope.recommendationEntry.data.ladderMethod
    };
    $scope.elementDisabled = !($scope.recommendationEntry.data.status === 'New' || $scope.recommendationEntry.data.status === 'Pending' || $scope.recommendationEntry.data.status === 'No Recom');
  }
  $scope.doCompare = function () {
    $scope.screenState.recommendationDetailsMode = 'competitiveView';
  };
  $scope.isResetAllDisabled = function () {
    var isResetAllDisabled = true;
    if (!$scope.elementDisabled) {
      _.forEach($scope.clonedHostLadder, function (clonedHostFare, index) {
        if ($scope.regularFbcFareLadder[index].effectiveTotalFare !== clonedHostFare.effectiveTotalFare) {
          isResetAllDisabled = false;
        }
      });
    }
    return isResetAllDisabled;
  };
  $scope.isIncrementOrDecrementBtnDisabled = function () {
    return $scope.incrementOrDecrementValue.value === '';
  };
  $scope.isRbdSpecificResetDisabled = function (index) {
    if (!$scope.elementDisabled) {
      return $scope.clonedHostLadder[index].effectiveTotalFare === $scope.regularFbcFareLadder[index].effectiveTotalFare;
    }
    return true;
  };
  $scope.resetRbdFare = function (index) {
    $scope.clonedHostLadder[index].effectiveTotalFare = $scope.regularFbcFareLadder[index].effectiveTotalFare;
    $scope.clonedHostLadder[index].recommendedTotalFare = $scope.regularFbcFareLadder[index].recommendedTotalFare;
    $scope.clonedHostLadder[index].rbdLabelCustomClass = getCustomRbdLabelCustomClass($scope.clonedHostLadder[index]);
    $scope.clonedHostLadder[index].effFareClass = 'fare-value effective-fare-section';
  };
  function incrementOrDecrementFare(percentageValue) {
    if ($scope.incrementOrDecrementValue.value !== '') {
      _.forEach($scope.clonedHostLadder, function (hostFare) {
        hostFare.effectiveTotalFare = _.toNumber((hostFare.effectiveTotalFare * percentageValue / 100).toFixed(FARE_PRECISION));
      });
      $scope.incrementOrDecrementValue.value = _.includes($scope.incrementOrDecrementValue.value, '%') ? $scope.incrementOrDecrementValue.value : $scope.incrementOrDecrementValue.value + '%';
    }
  }
  $scope.incrementFare = function () {
    var percentageValue = 100 + parseFloat($scope.incrementOrDecrementValue.value);
    incrementOrDecrementFare(percentageValue);
  };
  $scope.decrementFare = function () {
    var percentageValue = 100 - parseFloat($scope.incrementOrDecrementValue.value);
    incrementOrDecrementFare(percentageValue);
  };
  function getSmoothingMethodNames(smoothingMethods) {
    return _.map(smoothingMethods, function (smoothingMethod) {
      return smoothingMethod.label;
    });
  }
  function setTotalFareThreshold() {
    _.forEach($scope.clonedHostLadder, function (hostLadderEntry) {
      hostLadderEntry.minFareThreshold = alignFaresService.getTotalFareThreshold(hostLadderEntry.minFareThreshold, hostLadderEntry, hostLadderEntry.benchmarkFareComponent);
      hostLadderEntry.maxFareThreshold = alignFaresService.getTotalFareThreshold(hostLadderEntry.maxFareThreshold, hostLadderEntry, hostLadderEntry.benchmarkFareComponent);
    });
  }
  $scope.recalculateRecommendations = function () {
    var fareRecordKey = $scope.recommendationEntry.recomId;
    var smoothingMethod = $scope.defaultExponentialValue.value;
    var rbdVsEffectiveFares = {};
    for (var i = 0; i < $scope.clonedHostLadder.length; i++) {
      rbdVsEffectiveFares[$scope.clonedHostLadder[i].rbd] = $scope.clonedHostLadder[i].effectiveTotalFare.toString();
    }
    dataService.getRecalculatedRecommendationLadder(fareRecordKey, null, null, null, null, null, null, null, rbdVsEffectiveFares, smoothingMethod).then(function (data) {
      var ladder = dataTransformerService.createRecommendationGroup(data.recalculatedRecommendationLadder);
      var result = dataTransformerService.buildRecommendationLadderData(data.recalculatedRecommendationLadder, ladder);
      $scope.clonedHostLadder = saveAdjustedFaresService.getHostLadderData(result.groupedRows, $scope.clonedHostLadder, smoothingMethod);
      setTotalFareThreshold();
      $scope.clonedHostLadderForDisplay = $scope.clonedHostLadder;
      toastr.success('Recalculate Successful');
    });
  };
  $scope.saveAdjustments = function () {
    saveAdjustmentsService.saveAdjustments($scope.clonedHostLadder, $scope.recommendationEntry, $scope.screenState).then(function (data) {
      var result = dataTransformerService.transformRecommendationLadder(data)[0];
      $scope.recommendationEntry.data.showAdjustFares = false;
      $scope.clonedHostLadder = saveAdjustedFaresService.getHostLadderData(result.groupedRows, $scope.clonedHostLadder);
      setTotalFareThreshold();
      var selectedHostLadderData = $scope.screenState.recommendationDetailsPanel.selectedHostLadder;
      var fareLaddersInGroup = $scope.screenState.recommendationDetailsPanel.contextData.fareLaddersInGroup;
      saveAdjustedFaresService.updateGroupedRowsFares(result, $scope.recommendationEntry, selectedHostLadderData, $scope.clonedHostLadder, fareLaddersInGroup);
    });
  };
  $scope.effectiveFareChanged = function (index) {
    _.forEach($scope.clonedHostLadder, function (effFare) {
      if (effFare.effectiveTotalFare >= effFare.minFareThreshold && effFare.effectiveTotalFare <= effFare.maxFareThreshold) {
        effFare.effFareClass = 'fare-value effective-fare-section';
      }
    });
    $scope.clonedHostLadder[index].rbdLabelCustomClass = getCustomRbdLabelCustomClass($scope.clonedHostLadder[index]);
  };
  $scope.isUserAuthorizedForCurrentPos = function () {
    var pos = $scope.recommendationEntry.data.pos;
    return saveAdjustmentsService.isUserAuthorizedForCurrentPos(pos);
  };
  $scope.$watch('screenState.recommendChartMode', function (recommendMode, oldRecommendMode) {
    if (recommendMode && recommendMode !== oldRecommendMode && $scope.recommendationEntry.data.showAdjustFares) {
      $scope.recommendationEntry.data.showAdjustFares = false;
    }
  });
};
AdjustEffectiveFaresPanelController.$inject = ['$scope', 'FaresOptimizerAnalysisDataService', 'FaresOptimizerDataTransformerService', 'FaresOptimizerSaveAdjustedFaresService', 'ConfigurationService', 'FaresOptimizerAlignFaresService', 'FaresOptimizerSaveAdjustmentsService'];
module.exports = AdjustEffectiveFaresPanelController;